import ucenter_request from '@/utils/ucenter_request'
import bbsRequest from '@/utils/bbs_request'
import eduRequest from '@/utils/edu_request'
import request from '../utils/request'

import qs from 'qs'

/**
 * [获取注册信息]
 **/
export function getRegistInfo() {
  return ucenter_request({
    url: '/personal/Myinfo/getRegisInfo',
    method: 'get'
  })
}
/**
 * [获取注册信息-新接口-林杰]
 **/
export function getNewRegisInfo() {
  return ucenter_request({
    url: '/personal/Myinfo/getNewRegisInfo',
    method: 'get'
  })
}
/**
 * [获取注册信息-新接口-林杰]
 **/
export function newRegisInfo(params) {
  return ucenter_request({
    url: '/personal/Myinfo/newRegisInfo',
    method: 'post',
    contentType: 'application/x-www-from-urlencoded',
    data: qs.stringify(params)
  })
}
/**
 * [修改头像]
 **/
export function updateIcon(params) {
  return ucenter_request({
    url: '/personal/Myinfo/setAvatar',
    method: 'get',
    params: params
  })
}
/**
 * [发送手机验证码]
 **/
export function sendPhoneCode(params) {
  return ucenter_request({
    url: '/personal/Myinfo/sendMobileCode',
    method: 'get',
    params: params
  })
}
/**
 * [绑定手机号]
 **/
export function bindPhone(params) {
  return ucenter_request({
    url: '/personal/Myinfo/batchMobile',
    method: 'get',
    params: params
  })
}
/**
 * [发送邮箱验证码]
 **/
export function sendEmailCode(params) {
  return ucenter_request({
    url: '/personal/Myinfo/sendEmailCode',
    method: 'get',
    params: params
  })
}
/**
 * [绑定邮箱]
 **/
export function requestBindEmail(params) {
  return ucenter_request({
    url: '/personal/Myinfo/batchEmail',
    method: 'get',
    params: params
  })
}

/**
 * [修改注册信息]
 * realname：真实姓名
 * gender：手机号
 * birthday：2017-09-09
 * specialty_id：专业Id
 * province_id 省Id
 * city_id:市id
 * email：邮箱
 **/
export function updateRegistInfo(params) {
  return ucenter_request({
    url: '/personal/Myinfo/regisInfo',
    method: 'get',
    params: params
  })
}
/**
 * [获取专业列表]
 **/
export function getMajorList(params) {
  return ucenter_request({
    url: '/personal/Myinfo/getMajorList',
    method: 'get',
    params: params
  })
}

/**
 * [设置默认地址|删除地址]
 * id:必填
 * is_default：1：默认 0取消默认
 * status:删除传0 默认是1
 **/
export function setDefaultAndDelete(params) {
  return ucenter_request({
    url: '/user/address/updateAddress',
    method: 'get',
    params: params
  })
}

/**
 * [收货地址列表]
 **/
export function getUserAddressList() {
  return ucenter_request({
    url: 'user/address/getUserAddressList',
    method: 'get'
  })
}
/**
 * [收货地址列表]
 **/
export function getUserAddressListThree(params) {
  return ucenter_request({
    url: 'user/address/getPCCList',
    method: 'get',
    params: params
  })
}

/**
 * [获取修改地址信息]
 **/
export function getNeedEdiLocalInfo(params) {
  return ucenter_request({
    params: params,
    url: '/user/address/getOneAddressInfo',
    method: 'get'
  })
}
/**
 * [修改密码]
 **/
export function updatePwd(params) {
  return ucenter_request({
    params: params,
    url: '/personal/Myinfo/updatePassword',
    method: 'get'
  })
}
/**
 * [修改密码](新)
 **/
export function changePwd(params) {
  return ucenter_request({
    params: params,
    url: '/ucenter/user/changePwd',
    method: 'POST'
  })
}

/**
 * [修改密码 -- 发送验证码]
 **/
export function sendMobile(params) {
  return ucenter_request({
    params: params,
    url: '/user/pwd/sendMobile',
    method: 'get'
  })
}
/**
 * [修改密码 -- 验证手机验证码]
 **/
export function vertifyMobile(params) {
  return ucenter_request({
    params: params,
    url: '/user/pwd/vertifyMobile',
    method: 'get'
  })
}
/**
 * [修改密码 -- (最新)]
 **/
export function updatePwdNew(params) {
  return ucenter_request({
    params: params,
    url: '/user/pwd/updatePwd',
    method: 'get'
  })
}

/**
 * [添加/修改地址]
 * id:修改必填
 * receiver：收货人必填
 * mobile：手机号必填
 * province_id：省id 必填
 * city_id：市id 必填
 * detail_address：详细地址 必填
 **/
export function editAddress(params) {
  return ucenter_request({
    url: 'user/address/editAddress',
    method: 'get',
    params: params
  })
}

/**
 * [筑龙币记录]
 **/
export function getCoinLog(params) {
  return ucenter_request({
    url: '/personal/Myinfo/myInteg',
    method: 'get',
    params: params
  })
}

/**
 * [荣誉分记录]
 **/
export function getHonorLog(params) {
  return ucenter_request({
    url: '/personal/Myinfo/gloryScoreLog',
    method: 'get',
    params: params
  })
}

/**
 * [会员升级记录]
 **/
export function getVipUpdateLog(params) {
  return ucenter_request({
    url: '/personal/Myinfo/vipUpgradutingLog',
    method: 'get',
    params: params
  })
}

/**
 * [获取学历信息]
 **/
export function getEduConfig() {
  return ucenter_request({
    url: '/personal/Myinfo/getEduBackList',
    method: 'get'
  })
}

/**
 * [获取城市列表]
 * level 1 省 市
 * parent_id：省ID
 **/
export function getProvinceCityList(params) {
  return ucenter_request({
    url: '/personal/Myinfo/getProvinceCityList',
    method: 'get',
    params: params
  })
}

// 我的足迹---浏览帖子
export function myview(params) {
  return ucenter_request({
    url: 'learnCenter/mygroup/myview',
    method: 'get',
    params: params
  })
}

// 我的足迹--评测记录
export function getMySkexamBrowse(params) {
  return ucenter_request({
    url: 'learnCenter/browse/getMySkexamBrowse',
    method: 'get',
    params: params
  })
}

// 我的足迹--浏览课程
export function getMyLessonBrowse(params) {
  return ucenter_request({
    url: 'learnCenter/browse/getMyLessonBrowse',
    method: 'get',
    params: params
  })
}

/**
 * [个人主页---主题--列表下数据]
 **/
export function myPost(params) {
  return ucenter_request({
    url: '/personal/myinfo/myPost',
    method: 'get',
    params: params
  })
}

// [个人主页---档案--]
export function myArchive(params) {
  return ucenter_request({
    url: '/personal/Myinfo/myArchive',
    method: 'get',
    params: params
  })
}

// [个人主页---筑龙币--]
export function getRow(params) {
  return ucenter_request({
    url: '/setting/bbsscore/getRow',
    method: 'get',
    params: params
  })
}
// [个人主页---任务中心--]
export function newTaskIndex(params) {
  return ucenter_request({
    url: '/personal/Task/index',
    method: 'get',
    params: params
  })
}
// 满意度调查（获取）
export function getUserPostSatisfaction(params) {
  return ucenter_request({
    url: 'personal/myinfo/getUserPostSatisfaction',
    method: 'get',
    params: params
  })
}
// 满意度调查（保存）
export function saveUserPostSatisfaction(params) {
  return ucenter_request({
    url: 'personal/myinfo/saveUserPostSatisfaction',
    method: 'post',
    contentType: 'application/x-www-from-urlencoded',
    data: qs.stringify(params)
  })
}
export function exchangelist(params) {
  return ucenter_request({
    url: '/gift/gift/exchangeLog',
    method: 'get',
    params: params
  })
}
// 记录对应的收货地址
export function getaddress(params) {
  return ucenter_request({
    url: '/gift/gift/getAddress',
    method: 'get',
    params: params
  })
}
// 取消兑换
export function cancel(params) {
  return ucenter_request({
    url: '/gift/gift/cancel',
    method: 'get',
    params: params
  })
}

// 获取我的信息
export function getLoginUserInfo(params) {
  return ucenter_request({
    url: 'personal/myinfo/getUserinfo',
    params: params,
    method: 'get'
  })
}
// 我的筑龙
export function getMyZhulong(params) {
  return ucenter_request({
    url: 'personal/myinfo/myzhulong',
    params: params,
    method: 'get'
  })
}
// 我的筑龙 获取筑龙币
export function getMyScore(params) {
  return ucenter_request({
    url: 'personal/Myinfo/myScore',
    params: params,
    method: 'get'
  })
}
// 我的筑龙，设置防挂机弹框状态
export function setUserPopup(params) {
  return ucenter_request({
    url: 'personal/Myinfo/setUserPopup',
    params: params,
    method: 'get'
  })
}
// 我的筑龙，获取按钮状态
export function getUserPopup(params) {
  return ucenter_request({
    url: 'personal/Myinfo/getUserPopup',
    params: params,
    method: 'get'
  })
}

// 获取我的已购课程
export function getBuyLesson(params) {
  return ucenter_request({
    url: 'personal/Myinfo/myBuyLesson',
    params: params,
    method: 'get'
  })
}
// 获取推荐的课程
export function getCommendLesson(params) {
  return ucenter_request({
    url: 'personal/MyInfo/recommendLessonList',
    params: params,
    method: 'get'
  })
}
// 我的待支付课程
export function getWaitorOrders(params) {
  return ucenter_request({
    url: 'personal/Myinfo/myPayingLesson',
    params: params,
    method: 'get'
  })
}

// 取消订单
export function getCancelOrder(params) {
  return ucenter_request({
    url: 'personal/Myinfo/cancelOrder',
    params: params,
    method: 'get'
  })
}

// 我的收藏的课程
export function getMyCollectLesson(params) {
  return ucenter_request({
    url: 'personal/Myinfo/myCollectLesson',
    params: params,
    method: 'get'
  })
}
// 取消收藏课程
export function cancelCollectCourse(params) {
  return ucenter_request({
    url: 'personal/Myinfo/cancelCollectLesson',
    params: params,
    method: 'get'
  })
}
// 获取我的快递列表
export function getExpressList(params) {
  return ucenter_request({
    url: 'personal/Express',
    params: params,
    method: 'get'
  })
}
// 获取我的快递信息
export function getTrackingList(params) {
  return ucenter_request({
    url: 'gift/gift/logistic',
    // url: 'personal/Express/details',
    params: params,
    method: 'get'
  })
}
// 获取兑换记录快递信息
export function Scorelogistic(params) {
  return ucenter_request({
    url: 'gift/gift/Scorelogistic',
    // url: 'personal/Express/details',
    params: params,
    method: 'get'
  })
}
// 确认收货
export function confirmExpress(params) {
  return ucenter_request({
    url: 'personal/Express/confirm',
    params: params,
    method: 'get'
  })
}
// 用户档案
export function myArchiveInfo(params) {
  return ucenter_request({
    url: 'personal/Myinfo/myArchive',
    params: params,
    method: 'get'
  })
}
// 我的筑龙--推荐关注--关注用户
export function follows(params) {
  return ucenter_request({
    url: 'personal/myinfo/follows',
    params: params,
    method: 'get'
  })
}
// 我的筑龙--推荐关注--取消关注用户
export function cancelfollow(params) {
  return ucenter_request({
    url: 'personal/myinfo/cancelFollow',
    params: params,
    method: 'get'
  })
}

// *****==========  ↓↓  分割线  我的社区、我的资料、我的收藏   请求开始  ↓↓  ==========*****
// 我的社区--我关注的小组
export function myOfUser(params) {
  return ucenter_request({
    url: 'user/bbs/careOfUser',
    method: 'get',
    params: params
  })
}

// 我的社区--我关注的小组
export function mygroup(params) {
  return ucenter_request({
    url: 'personal/myinfo/myAttendGroup',
    method: 'get',
    params: params
  })
}

// 我的社区--我的发帖
export function mypost(params) {
  return ucenter_request({
    url: 'personal/myinfo/myPost',
    method: 'get',
    params: params
  })
}

// 我的社区--我的回帖
export function myreplypost(params) {
  return ucenter_request({
    url: 'personal/myinfo/myReplyPost',
    method: 'get',
    params: params
  })
}

// 我的资料--我的下载
export function mydown(params) {
  return ucenter_request({
    url: 'personal/Materials/download',
    method: 'get',
    params: params
  })
}

// 我的资料--我的上传
export function myupload(params) {
  return ucenter_request({
    url: 'personal/Materials/upload',
    method: 'get',
    params: params
  })
}

// 我的资料---收藏的资料
export function mycollection(params) {
  return ucenter_request({
    url: 'personal/Materials/collection',
    method: 'get',
    params: params
  })
}

// 我的收藏--收藏的资料
export function mycollection_data(params) {
  return ucenter_request({
    url: 'personal/Myinfo/myCollectResource',
    method: 'get',
    params: params
  })
}

// 我的收藏--收藏的帖子
export function mycollection_thread(params) {
  return ucenter_request({
    url: 'personal/Myinfo/myCollectInvatation',
    method: 'get',
    params: params
  })
}

// *****==========  ↑↑  分割线  我的社区、我的资料、我的收藏   请求开始  ↑↑  ==========*****

// 个人主页 -- 发帖
export function homepageThread(params) {
  return ucenter_request({
    url: 'personal/myinfo/myPost',
    method: 'get',
    params: params
  })
}

// 发票状态
export function getInvoiceStatus(params) {
  return ucenter_request({
    url: 'lesson/invoice/getInvoiceStatus',
    method: 'get',
    params: params
  })
}

// 开发票，获取发票类型、发票内容等
export function InvoiceSetInfo(params) {
  return ucenter_request({
    url: 'lesson/Invoice/getInvoiceSetInfo',
    method: 'get',
    params: params
  })
}

// 开发票，保存
export function SaveInvoice(params) {
  return ucenter_request({
    url: 'lesson/invoice/saveInvoice',
    method: 'get',
    params: params
  })
}

// 开发票，保存
export function editOrderAddress(params) {
  return ucenter_request({
    url: 'personal/Myinfo/editOrderAddress',
    method: 'get',
    params: params
  })
}
// 免费课程
export function myFreeLesson(params) {
  return ucenter_request({
    url: 'personal/Myinfo/myFreeLesson',
    method: 'get',
    params: params
  })
}
// 我的优惠券 - 未使用
export function couponUnused(params) {
  return ucenter_request({
    url: 'personal/Coupon/unused',
    method: 'get',
    params: params
  })
}
// 我的优惠券 - 已过期
export function couponExpires(params) {
  return ucenter_request({
    url: 'personal/Coupon/expires',
    method: 'get',
    params: params
  })
}

// 我的优惠券 - 已使用
export function couponUsed(params) {
  return ucenter_request({
    url: 'personal/Coupon/used',
    method: 'get',
    params: params
  })
}
export function getUserReviewListNew(params) {
  return eduRequest({
    url: 'review/review/getUserReviewListNew',
    method: 'get',
    params
  })
}
export function upReviewCertUsername(params) {
  return eduRequest({
    url: '/review/review/upReviewCertUsername',
    method: 'get',
    params
  })
}

// // 获取省市地区
// export function getDistrict(params) {
//   return payRequest({
//     url: '/pay/address/getDistrict',
//     method: 'get',
//     params: params
//   })
// }

// 推荐可关注的人
export function followList(params) {
  return ucenter_request({
    url: '/personal/Task/followList',
    method: 'get',
    params: params
  })
}
// 添加关注
export function addFollow(params) {
  return bbsRequest({
    url: '/user/follow/follow',
    method: 'get',
    params: params
  })
}

// 完成关注任务领奖接口
export function followGetScore(params) {
  return ucenter_request({
    url: '/personal/Task/followGetScore',
    method: 'get',
    params: params
  })
}
// 签到
export function signReq(params) {
  return ucenter_request({
    url: '/api/user/sign',
    method: 'get',
    params: params
  })
}

export function get_imgId(params) {
  return ucenter_request({
    url: 'personal/Certification/searchCertification',
    method: 'get',
    params
  })
}
export function get_img(params) {
  return ucenter_request({
    url: 'personal/certification/downCertification',
    method: 'get',
    params
  })
}
export function get_infos(params) {
  return ucenter_request({
    url: 'personal/Certification/getCertificationInfo',
    method: 'get',
    params
  })
}
// 获取左侧菜单
export function getMenuApi(params) {
  return ucenter_request({
    url: 'zkb/index/menu',
    method: 'get',
    params
  })
}
// 证书查询列表
export function searchCertification(params) {
  return ucenter_request({
    url: 'personal/Certification/searchCertification',
    method: 'get',
    params
  })
}
// 个人中心
export function getShopApp(params) {
  return request({
    url: 'top/top/getShopApp',
    method: 'get',
    params
  })
}

// 获取协议信息
export function getAgreementInfo(params) {
  return ucenter_request({
    url: 'personal/Agreement/getAgreementInfo',
    method: 'post',
    params
  })
}

// 确定协议
export function confirmAgreement(params) {
  return ucenter_request({
    url: 'personal/Agreement/confirmAgreement',
    method: 'post',
    params
  })
}

// 获取专家信息
export function getRegisInfoByToken(params) {
  return ucenter_request({
    url: '/personal/Myinfo/getRegisInfoByToken',
    method: 'get',
    params: params
  })
}
// 保存专家信息
export function regisInfoByToken(params) {
  return ucenter_request({
    url: '/personal/Myinfo/regisInfoByToken',
    method: 'get',
    params: params
  })
}
